import React from "react";

/**
 * BrandMark — the Holy Words app icon.
 *
 * Now renders the real `/icons/icon-512.png` (the red-glass cathedral
 * design with gold HW + Bible + play arrow) so the header logo,
 * favicon-like marks, and any in-app brand placements all match the
 * Play Store icon exactly. Previously we used an inline SVG which
 * looked similar but was a totally separate artifact — replacing the
 * Play Store icon alone wouldn't update the app's chrome.
 *
 * Props:
 *   size      – pixel dimension (square). Defaults to 36 for header.
 *   className – additional Tailwind classes for the outer wrapper.
 */
export default function BrandMark({ size = 36, className = "" }) {
  return (
    <span
      className={`inline-block shrink-0 overflow-hidden rounded-[22%] ${className}`}
      style={{ width: size, height: size }}
      aria-label="Holy Words"
      data-testid="brand-mark"
    >
      <img
        src="/icons/icon-512.png?v=3"
        alt="Holy Words"
        width={size}
        height={size}
        loading="eager"
        decoding="async"
        className="w-full h-full object-cover"
        // Bust the browser cache so users see the new logo the moment
        // they reload — without this, anyone who visited holywords144.com
        // before would still see the old terracotta HW for hours.
        style={{ imageRendering: "auto" }}
      />
    </span>
  );
}
